var _defs, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoIconRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "warning",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #e32a34;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_11914",
    "data-name": "Path 11914",
    className: "cls-1",
    d: "M8,14a6,6,0,1,1,6-6A6,6,0,0,1,8,14ZM8,2.857A5.143,5.143,0,1,0,13.143,8,5.143,5.143,0,0,0,8,2.857Z",
    transform: "translate(-2 -2)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11765",
    "data-name": "Group 11765",
    transform: "translate(5.358 2.571)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3634",
    "data-name": "Rectangle 3634",
    className: "cls-1",
    width: 0.857,
    height: 4.714,
    transform: "translate(0.214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11915",
    "data-name": "Path 11915",
    className: "cls-1",
    d: "M15.143,22a.643.643,0,1,0,.643.643A.643.643,0,0,0,15.143,22Z",
    transform: "translate(-14.5 -16.428)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIconRed);
export default __webpack_public_path__ + "static/media/InfoIconRed.bb4c3d4d3115c68faaaa60e93732b206.svg";
export { ForwardRef as ReactComponent };